module.exports = __webpack_public_path__ + "img/mono-gateway.58f623fc.svg";